const AMOUNT_LONG_MULTIPLIER = 100000;

/**
 * Converts string amount to numeric representation in LONG type required
 * by BI system
 */
export function amountToLong(amount: string | undefined): number {
  if (Number.isNaN(Number(amount))) {
    return 0;
  }
  return Math.floor(Number(amount) * AMOUNT_LONG_MULTIPLIER);
}
